module.exports = __webpack_public_path__ + "img/roboto-v27-latin-ext_latin-700.9cc0e61.svg";